<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<template>
  <section class="work-process-new ptb-10 gray-light-bg">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-9 col-lg-8">
          <div class="section-heading text-center mb-5">
            <h2>{{ t('work_process.title') }}</h2>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="work-process-wrap text-center">
            <div
              class="single-work-process"
              v-for="(n, index) in 4"
              :key="index"
            >
              <div class="work-process-icon-wrap secondary-bg rounded">
                <i class="fa-solid fa-gears icon-md text-white"></i>
                <span class="process-step white-bg color-primary shadow-sm">
                  {{ index + 1 }}
                </span>
              </div>

              <span class="work-process-divider"></span>

              <div class="work-process-content mt-6">
                <h5>{{ t(`work_process.steps[${index}].title`) }}</h5>
                <p>{{ t(`work_process.steps[${index}].description`) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
